export enum VerityPriceTableStates {
    EXTERNAL,
    INTERNAL
}
